import { GATEWAY_BASE_URL, CONSOLE_REGISTER_URL, CONSOLE_WEB_URL } from '../../config/endpoints.ts';

function Code({ children }: { readonly children: string }): JSX.Element {
  return (
    <pre className="my-4 overflow-x-auto rounded-xl bg-ink p-5 font-mono text-[13px] leading-relaxed text-linen">
      <code>{children}</code>
    </pre>
  );
}

function Step({ n, title, children }: { readonly n: number; readonly title: string; readonly children: React.ReactNode }): JSX.Element {
  return (
    <div className="flex gap-4 mb-8">
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-claude text-[13px] font-bold text-linen">{n}</div>
      <div className="flex-1">
        <h3 className="text-[16px] font-semibold text-ink mb-2">{title}</h3>
        {children}
      </div>
    </div>
  );
}

export function GettingStarted(): JSX.Element {
  return (
    <article>
      <h1 className="text-[28px] font-semibold text-ink mb-2">快速开始</h1>
      <p className="text-ink-muted mb-10">五分钟内完成注册、充值、接入，开始使用 Claude / GPT 全系模型。</p>

      <Step n={1} title="注册账号">
        <p className="text-ink-muted mb-2">
          访问 <a href={CONSOLE_REGISTER_URL} className="text-claude hover:underline">{CONSOLE_REGISTER_URL}</a>，使用邮箱注册。注册后自动创建组织和初始余额。
        </p>
      </Step>

      <Step n={2} title="充值余额">
        <p className="text-ink-muted mb-2">
          登录控制台，进入「余额」页面，选择充值金额完成支付。当前支持微信支付充值。余额以人民币计价，使用时按模型定价实时扣费。
        </p>
      </Step>

      <Step n={3} title="创建 API Key">
        <p className="text-ink-muted mb-2">
          在控制台的「API Keys」页面，点击「创建密钥」。创建时需要选择一个渠道，渠道决定了你使用各模型的价格倍率。创建后请立即复制保存，密钥只展示一次。
        </p>
      </Step>

      <Step n={4} title="配置接入端点">
        <p className="text-ink-muted mb-2">
          将 API 请求的 Base URL 指向哪都通网关，替换官方地址即可：
        </p>
        <Code>{`# 接入端点
${GATEWAY_BASE_URL}

# 等效于 Anthropic 官方的 https://api.anthropic.com
# 协议完全兼容，无需修改任何请求参数`}</Code>
      </Step>

      <Step n={5} title="测试连通">
        <p className="text-ink-muted mb-2">使用 curl 验证一切正常：</p>
        <Code>{`curl ${GATEWAY_BASE_URL}/v1/messages \\
  -H "x-api-key: YOUR_API_KEY" \\
  -H "content-type: application/json" \\
  -H "anthropic-version: 2023-06-01" \\
  -d '{
    "model": "claude-sonnet-4-6",
    "max_tokens": 256,
    "messages": [{"role": "user", "content": "你好"}]
  }'`}</Code>
        <p className="text-ink-muted">
          收到正常 JSON 响应即表示接入成功。接下来可以配置你常用的 AI 工具。
        </p>
      </Step>
    </article>
  );
}
